import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { queryKeys } from '@/lib/query-keys'
import { useWorkspaces } from './useWorkspaces'

export interface ImportBatch {
  id: string;
  created_at: string;
  file_name: string;
  status: 'processing' | 'completed' | 'failed' | 'reverted';
  contacts_imported: number;
  error_message?: string;
}

async function fetchImportHistory(workspaceId: string): Promise<ImportBatch[]> {
  if (!workspaceId) return [];

  const { data, error } = await supabase
    .from('import_batches')
    .select('*')
    .eq('workspace_id', workspaceId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error fetching import history:', error);
    throw new Error(error.message);
  }

  return data as ImportBatch[];
}

export function useImportHistory() {
  const { currentWorkspace } = useWorkspaces();

  return useQuery({
    queryKey: queryKeys.importHistory.list(currentWorkspace?.id),
    queryFn: () => fetchImportHistory(currentWorkspace!.id),
    enabled: !!currentWorkspace?.id,
    refetchInterval: 5000, // Refetch every 5 seconds to check for status updates
    staleTime: 0, // Consider data immediately stale
    gcTime: 1000 * 60, // Cache for 1 minute max
  });
}
